import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class MfaBackup extends SnModel {
  @Expose()
  public tokens: any[];

  @Expose()
  public password: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
